module.exports = __webpack_public_path__ + "img/headset.0d1419b4.svg";